module.exports = __webpack_public_path__ + "img/201711-2.185c2ea2.jpg";